<template>
  <v-app>
    <router-view />
    <v-overlay z-index="1000" :value="$store.getters['loader/show']">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>
<script>
  export default {};
</script>
<style>
  .swal2-container {
    font-family: "Roboto", sans-serif !important;
    color: black;
  }
  .swal2-select {
    -moz-appearance: auto;
    -webkit-appearance: auto;
  }
</style>
